import { Chart, registerables } from 'chart.js';
import { extractData } from "../utils";
Chart.register(...registerables);
const chartDataElement = document.getElementById('chart_data');
const chartData = extractData(chartDataElement) ?? [];
const BRAND_COLOR = '#f5809d';
const SECONDARY_COLOR = '#24252e';
const PLACEHOLDER_COLOR = '#9DABB5';
const valueLabelsPlugin = {
    id: 'valueLabels',
    afterDatasetsDraw(chart) {
        const { ctx, data, chartArea } = chart;
        ctx.save();
        ctx.font = '12px sans-serif';
        ctx.textAlign = 'center';
        chart.getDatasetMeta(0).data.forEach((point, index) => {
            const value = data.datasets[0]?.data[index];
            const label = data.labels?.[index];
            if (typeof value !== 'number' || typeof label !== 'string')
                return;
            const { x, y } = point.tooltipPosition();
            ctx.fillStyle = PLACEHOLDER_COLOR;
            ctx.textBaseline = 'bottom';
            ctx.fillText(String(value), x, y - 4);
            ctx.fillStyle = SECONDARY_COLOR;
            ctx.textBaseline = 'bottom';
            ctx.fillText(label, x, chartArea.bottom + 20);
        });
        ctx.restore();
    },
};
Chart.register(valueLabelsPlugin);
const baseOptions = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
        padding: { top: 20, left: 20, right: 20, bottom: 20 },
    },
    plugins: {
        legend: { display: false },
        tooltip: { enabled: false },
    },
    scales: {
        x: {
            display: false,
            grid: { display: false },
        },
        y: {
            display: false,
            beginAtZero: true,
        },
    },
    elements: {
        point: { radius: 2 },
    },
};
function createDataset(ctx, values) {
    const gradient = ctx.createLinearGradient(0, 0, 0, ctx.canvas.height);
    gradient.addColorStop(0, 'rgba(255, 221, 229, 1)');
    gradient.addColorStop(1, 'rgba(255, 255, 255, 0)');
    return {
        data: values,
        borderColor: BRAND_COLOR,
        borderWidth: 2,
        backgroundColor: gradient,
        pointBorderColor: SECONDARY_COLOR,
        pointBackgroundColor: BRAND_COLOR,
        pointBorderWidth: 1,
        tension: 0.32,
        fill: 'start',
    };
}
export default function initPerfumeCharts() {
    const charts = [];
    for (const { canvasId, labels, values } of chartData) {
        const canvas = document.getElementById(canvasId);
        const ctx = canvas?.getContext('2d');
        if (!ctx)
            continue;
        charts.push(new Chart(ctx, {
            type: 'line',
            data: { labels, datasets: [createDataset(ctx, values)] },
            options: baseOptions,
        }));
    }
    return charts;
}
